import React from 'react';


// Screen Import
import { HomeScreen } from '../pages/home';
import { LoginScreen } from '../pages/login';
import { NotFoundScreen } from '../pages/404';
import { RegisterScreen } from '../pages/register';
import { ListProductScreen } from '../pages/listProduct';

// Internal Import
import { defaultLoginData } from './types/login.type';

// External Import
import { Routes, Route } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import { UnauthorizedScreen } from '../pages/unauthorized';
import { DetailProductScreen } from '../pages/detailProduct';
import { PromotionsScreen } from '../pages/listPromotion';

export interface RouterProps { }



export const RouterScreen: React.FC<RouterProps> = () => {

    ReactSession.setStoreType("localStorage");

    return (
        <Routes>
            
            <Route path='*' element={<NotFoundScreen />} />

            <Route path='/' element={<HomeScreen />} />
            <Route path='/home' element={<HomeScreen />} />

            <Route path='/login' element={<LoginScreen />} />
            <Route path='/register' element={<RegisterScreen />} />
            <Route path='/unauthorized' element={<UnauthorizedScreen />} />

            <Route path='/products' element={<ListProductScreen />} />
            <Route path='/products/:t/:min/:max' element={<ListProductScreen />} />
            <Route path='/products/:s/:t/:min/:max' element={<ListProductScreen />} />

            <Route path='/product/:id' element={<DetailProductScreen />} />

            
            <Route path='/promotions' element={<PromotionsScreen />} />
        </Routes>
    );
}
